const colors = {
  purple: "#DA45FF",
  yellow: "#FFEC00",
  orange: "#FF8A00",
  lightBlue: "#07B4E8",
  blue: "#2467FE",
  darkBlue: "#00141A",
  red: "#FF4553",
  lightGreen: "#00FF4E",
  green: "#05CB24",
  darkGreen: "#28A745",
  white: "#FFFFFF",
  silver: "#C3C3C3",
  grey: "#8D8D8D",
  dimGrey: "#606060",
  darkGrey: "#434343",
  charcoal: "#3C3C3C",
  black1: "#000000",
  black2: "#1F1F1F",
  black3: "#1A1A1A",
  black4: "#101010",
  black5: "#171717",
}

export default colors;
